import * as React from "react";
import { SVGProps } from "react";
const SvgChangeContract02 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#change-contract-02_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.323 14.21a1 1 0 0 1 1.228 1.579C10.754 17.967 8.514 20.05 6.87 22h19.132a1 1 0 0 1 0 2H6.872c1.643 1.951 3.884 4.035 6.68 6.211a1 1 0 1 1-1.228 1.578c-3.505-2.727-6.191-5.34-7.983-7.767a1.712 1.712 0 0 1 0-2.044c1.79-2.425 4.476-5.04 7.982-7.767v-.001Zm7.354-14c3.506 2.729 6.192 5.343 7.982 7.768.451.608.452 1.43 0 2.044-1.792 2.426-4.478 5.04-7.983 7.767a1 1 0 0 1-1.228-1.578c2.796-2.177 5.037-4.26 6.68-6.21L6.001 10a1 1 0 1 1 0-2H25.13c-1.643-1.95-3.883-4.034-6.68-6.211A1 1 0 1 1 19.677.21Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="change-contract-02_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChangeContract02;
